import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/store";
import { MapStyle, setMapStyle } from "@/features/map-view/mapSlice";
import React from "react";

function MapOptions() {
  const mapStyle = useSelector(
    (state: RootState) => state.rootReducer.mapViewReducer.mapStyle
  );

  const dispatch = useDispatch<AppDispatch>();

  function changeMapStyle(value: MapStyle) {
    dispatch(setMapStyle(value));
  }

  const radioButtonStyle = "flex items-center space-x-2";

  return (
    <Card className="">
      {/* Map Options Section */}
      <CardHeader className="p-3 bg-slate-100">
        <CardTitle className="text-lg font-semibold !p-0 !m-0">
          Map Options
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="mt-2">
          <div>
            <RadioGroup
              className="space-y-2"
              value={mapStyle}
              onValueChange={(value) => changeMapStyle(value as MapStyle)}
            >
              <div className={radioButtonStyle}>
                <RadioGroupItem id="automatic" value="automatic" />
                <Label
                  className="cursor-pointer text-[16px]"
                  htmlFor="automatic"
                >
                  Automatic
                </Label>
              </div>
              <div className={radioButtonStyle}>
                <RadioGroupItem id="satellite" value="satellite" />
                <Label
                  className="cursor-pointer text-[16px]"
                  htmlFor="satellite"
                >
                  Satellite
                </Label>
              </div>
              <div className={radioButtonStyle}>
                <RadioGroupItem id="street" value="street" />
                <Label className="cursor-pointer text-[16px]" htmlFor="street">
                  Street
                </Label>
              </div>
              {/* <div className={radioButtonStyle}>
                <RadioGroupItem id="outdoor" value="outdoor" />
                <Label className="cursor-pointer text-[16px]" htmlFor="outdoor">
                  Outdoor
                </Label>
              </div> */}
            </RadioGroup>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default React.memo(MapOptions);
